<template>
  <div class="componentSty">
    <m-title :titlelist="listitem"></m-title>
    <div class="componentSty_content">
      <div class="componentSty_content_title">
        <span class="fonints">时间选择</span>
        <el-date-picker v-model.trim="year" type="year" value-format="yyyy" placeholder="请选择年份">
        </el-date-picker>
        <div class="cheboxSty">
          <el-radio v-model="radio" label="0">统计车数</el-radio>
          <el-radio v-model="radio" label="1">统计吨数</el-radio>
        </div>
      </div>
      <div class="componentSty_content_table">
        <table class="tableSty" cellpadding="0px" cellspacing="0px" v-if="tabledata.length">
          <tr>
            <th class="thSty" v-for="item in titleList" :key="item">
              {{ item }}
            </th>
          </tr>
          <tr v-for="(item,index) in tabledata" :key="index">
            <td style="borderTop:1px solid #f3f4f5;borderBottom:1px solid #f3f4f5;">
              {{item.areaName}}
            </td>
            <td
              colspan="14"
            >
              <table class="tableSty" cellpadding="0px" cellspacing="1px">
                <tr v-for="(item1,index1) in item.flowBalanceStatisticsFlowDetailsDtos" :key="index1">
                  <td style="borderRight: 1px solid #f3f4f5">{{item1.custmername}}</td>
                  <td colspan="13">
                    <table class="tableSty" cellpadding="0px" cellspacing="0px">
                      <tr class="rowSty" v-for="(item2,index2) in item1.flowBalanceStatisticsFleetDetailsDtos" :key="index2">
                        <td class="tdSty">{{item2.fleetNames}}</td>
                        <td colspan="12">
                          <table
                            class="tableSty"
                            width="100%"
                            cellpadding="0"
                            cellspacing="0"
                          >
                            <tr>
                              <td class="tdSty" v-for="(item3,index3) in mounths" :key="index3">
                                <span>{{radio==0?item2[item3]:item2[item3]/1000}}</span>
                              </td>
                            </tr>
                          </table>
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import mTitle from "@/components/mTitle";
export default {
  data() {
    return {
      listitem: [{ name: "统计分析" }, { name: "区域流向" }],
      titleList: [
        "区域",
        "流向",
        "代理",
        "1月",
        "2月",
        "3月",
        "4月",
        "5月",
        "6月",
        "7月",
        "8月",
        "9月",
        "10月",
        "11月",
        "12月",
      ],
      mounths:["january","february","march","april","may","june","july","august","september","october","november","december"],
      tabledata:[],
      year: "", //年
      radio:"0"
    };
  },
  watch:{
    year(nval,oldval){
     this.getTableMsg();
    },
    radio(nval,oldval){
      this.getTableMsg();
    },
  },
  components:{
    mTitle
  },
  methods: {
    async getTableMsg() {
      if(!this.year) return this.$message.info("请选择年份");
      let path = this.radio==="0"
        ? "/statistics/carsuttlenumber/flowBalanceStatisticsCarCount"
        : "/statistics/carsuttlenumber/flowBalanceStatisticsTonnage";
      const { data } = await this.$http("api1", path, "get", {year:this.year});
      if(data.code!=0) return this.$message.error(data.msg);
      this.tabledata=data.data;
    },
  },
};
</script>
<style lang="scss" src="@/assets/components.scss" scoped></style>
<style lang="scss" scoped>
.tableSty {
  font-size: 80%;
  word-break: break-all;
  table-layout: fixed;
  width: 100%;
  background-color: #f3f4f5;
  .thSty {
    background-color: #ffffff;
    height: 45px;
    border-left: 1px solid #f3f4f5;
  }
  .thSty:first-child {
    border-left: none;
  }
  td {
    text-align: center;
    height: 45px;
    background-color: #fdfdfd;
  }
  .tdSty {
    border-right: 1px solid #f3f4f5;
    border-bottom: 1px solid #f3f4f5;
  }
  .rowSty:last-of-type .tdSty {
    border-bottom: none;
  }
}
</style>


